import Box from "@mui/material/Box";
import { useEffect, useState } from "react";

import { usePathname } from "src/routes/hooks";
import { useResponsive } from "src/hooks/use-responsive";

import Footer from "./footer";
import Header from "./header";

import {
  WhiteLabelContext,
  WhiteLabelConfig,
} from "src/context/WhiteLabelContext";
import PlacenetAuthentication from "src/components/placenet-authentication/placenet-authentication";

// ----------------------------------------------------------------------

type Props = {
  children: React.ReactNode;
};

export default function MainLayout({ children }: Props) {
  const pathname = usePathname();

  const homePage = pathname === "/";
  const mdUp = useResponsive("up", "md");

  const isLiveCalendar = window.location.href.includes("livecalendar");

  const [whitelabelConfig, setWhitelabelConfig] = useState<WhiteLabelConfig>(
    {}
  );
  const [configLoaded, setConfigLoaded] = useState(false);

  useEffect(() => {
    const match = pathname.match(/\/sportprovider\/([^\/]+)/);
    const providerSlug = match?.[1];

    if (providerSlug) {
      fetch(`/src/assets/whitelabel/data/${providerSlug}.json`)
        .then((res) => res.json())
        .then(setWhitelabelConfig)
        .catch(() => setWhitelabelConfig({}))
        .finally(() => setConfigLoaded(true));
    } else {
      setConfigLoaded(true);
      setWhitelabelConfig({});
    }
  }, [pathname]);

  if (!configLoaded) return null;

  return (
    <WhiteLabelContext.Provider value={whitelabelConfig}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          background: whitelabelConfig.backgroundColor,
        }}
      >
        <PlacenetAuthentication />

        {!whitelabelConfig.hideHeader && !isLiveCalendar && <Header />}

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            mt: 3,
            ...(!homePage &&
              {
                // pt: { xs: 8, md: 10 },
              }),
          }}
        >
          {children}
        </Box>

        {!isLiveCalendar && !whitelabelConfig.hideFooter && <Footer />}
      </Box>
    </WhiteLabelContext.Provider>
  );
}
